/*
 * @Author: czj
 * @Date: 2025-03-31 11:05:00
 * @Description: 
 * @FilePath: \test-demo2\src\Store\index.js
 */

import { defineStore } from 'pinia';
// import { ref } from 'vue';


// 存储 app_id
export const useStore = defineStore('app', {
  state: () => {
    return {
      ticket: null, //身份票据
      app_id: null,// 应用ID
      task_id: null,// 任务ID
      process_form: null,//顶部表单数据
      category_name: null,//分类名称;没有值则get_template_config 返回模板。有值 返回...

      all_colors: {},//所有颜色,颜色组件的颜色数据
    };
  },
  actions: {
    setAppId(id) {
      this.app_id = id;
    },
    setTaskId(id) {
      this.task_id = id;
    },
    setTicket(ticket) {
      this.ticket = ticket;
    },
    setProcessForm(form) {
      this.process_form = form;
    },
    setCategoryName(name) {
      this.category_name = name;
    },
    //初始化
    initStore() {
      this.app_id = null;
      this.task_id = null;
      this.ticket = null;
      this.process_form = null;
      this.category_name = null;
    },
    setAllColors(colors) {
      this.all_colors = colors;
    }
  },
});